import axios from "axios";
import idTokenInterceptor from "./interceptors";

const authClient = axios.create();

// CAREFUL: Interceptors are applied in reverse order! https://github.com/axios/axios/issues/1663
authClient.interceptors.request.use(idTokenInterceptor);

export default authClient;
